import axios from 'axios';
import { SERVER_URL } from 'Constants';
import { LanguageEntity } from 'Models/Entities';
import { bookingType } from 'Models/Enums';

export interface AddToWaitlistDto {
	ferryTripId: string;
	email: string;
	userId?: string;
	joinPassengerWaitlist: boolean;
	joinVehicleWaitlist: boolean;
	joinTrailerWaitlist: boolean;
	/** The fare type wanted, or undefined for any. Only sent where the site sells fare types. */
	passengerClassId?: string;
	/** How many are travelling. Undefined means one. */
	partySize?: number;
	/**
	 * True to hear about any opening, false to wait until the whole party fits.
	 *
	 * <p>Independent of the fare type: a site that sells none still has parties who would rather not
	 * be told about a single seat.</p>
	 */
	notifyOnPartialSpace?: boolean;
}

export interface RemoveFromWaitlistDto {
	departureName: string;
	destinationName: string;
	moreInformation: {
		departureDateTime: Date;
		bookingType: bookingType;
	}[];
}

/**
 * Adds a user/email address to a waitlist for the selected ferry trip
 * @param addToWaitlistDto: contains ferryTripId, bookingType (e.g. vehicle/passenger only), email address and userId
 */
export async function addToWaitList(addToWaitlistDto: AddToWaitlistDto) {
	return axios.post(`${SERVER_URL}/api/entity/WaitlistItemEntity/add-to-waitlist`, addToWaitlistDto);
}

/**
 * Removes a user/email address from a waitlist
 * @param waitlistItemId
 * @param removeFromAllWaitlists
 */
export async function removeFromWaitlist(
	waitlistItemId: string,
	removeFromAllWaitlists: boolean,
): Promise<RemoveFromWaitlistDto[]> {
	const result = await axios.post(
		`${SERVER_URL}/api/entity/WaitlistItemEntity/remove-from-waitlist?waitlistItemId=${waitlistItemId}&removeFromAllWaitlists=${removeFromAllWaitlists}`,
	);
	return result.data as RemoveFromWaitlistDto[];
}

/**
 * Gets all the (non-removed) items on a ferry trip waitlits
 * @param ferryTripId: the waitlist item that will be set to `REMOVED`
 */
export async function getAllWaitlistItems(ferryTripId: string) {
	return axios.post(`${SERVER_URL}/api/entity/WaitlistItemEntity/get-all-waitlist-items?ferryTripId=${ferryTripId}`);
}
